/* @flow strict */

import * as React from 'react';
import { withRouter } from 'react-router-dom';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import { GET, GET_WITH_REDIRECT, PUT } from '/client/src/api';
import CssPinner from '/client/src/components/csspinner';
import Credentials from '/client/src/api/Credentials';
import { flags } from '/client/src/constants';
import { stripeData } from '/client/src/utils/checkStripeData';

import './styles.scss';

type PropsType = {
  wellcomCb?: (props: {}) => void,
  settings?: {
    payData: {}
  },
  withoutRequest?: any
};

class StripeConnection extends React.Component<PropsType> {
  static contextType = DefaultContainerContext;

  constructor(props: PropsType) {
    super(props);

    this.state = {
      methods: []
    };

    this.languageWrap = React.createRef();
  }

  componentDidMount() {
    if (!this.props.withoutRequest) {
      this.loadMethods();
    } else {
      this.setState({
        methods: this.props.settings.payData
      });

      CssPinner(this.languageWrap.current, false);
    }
  }

  loadMethods = async () => {
    try {
      const { result } = await GET('/api/v1/1/merchants/paymentmethod/stripe_token_direct/settings');
      const {
        connectedAccount
      } = stripeData(result, this.context);

      this.setState({
        methods: result,
        connectedAccount
      });

      if (this.props.wellcomCb) {
        this.props.wellcomCb(this.props);
      }

      CssPinner(this.languageWrap.current, false);
    } catch (e) {
      console.log(e);
      CssPinner(this.languageWrap.current, false);
    }
  }

  confirmChangeCurrency = (currency: string) => {
    this.context.handleShowSystemDialog(true, {
      systemDialogType: 'warning',
      systemDialogTitle: 'Hmmm...',
      systemDialogCallback: () => {
        this.handleChangeCurrency(currency);
      },
      systemDialogCallbackActions: ['Ok', 'Cancel'],
      systemDialogContent: ('Changing system currency after ticket sales have started may affect the correct display of event analytics. Would you like to continue?')
    });
  }

  handleChangeCurrency = async (currency: string) => {
    try {
      CssPinner(this.languageWrap.current, true);

      await PUT('/api/v1/1/merchants/currency', { currency });

      CssPinner(this.languageWrap.current, false);

      this.context.setProfileCurrent({
        ...this.context.profileCurrent,
        currency
      });
    } catch (e) {
      console.log(e);

      CssPinner(this.languageWrap.current, false);
    }
  }

  handleStripeControl = async () => {
    const token = Credentials.getToken();

    window.localStorage.setItem('SPARXO_lastPage', window.location.pathname);

    await GET_WITH_REDIRECT(`/api/v1/1/merchants/payment/stripe/auth?access_token=${token}`, {
      chnageRedirect: `${window.location.origin}/payment/stripe/oauth2/callback`
    });
  }

  render(): React.Element<'div'> {
    const { methods } = this.state;
    const { settings } = this.props;
    const { profileCurrent } = this.context;
    const isIssetStripeAccount = this.state.connectedAccount || (settings && settings.connectedAccount);

    return (
      <>
        <ul className="EditLanguageList csspinner" ref={this.languageWrap}>
          {_.map(methods, (mi: {}, mk: number): React.Element<'li'> => {
            return (
              <li
                onClick={() => {
                  this.confirmChangeCurrency(mi.currency);
                }}
                className={`EditLanguageListItem ${mi.currency === profileCurrent.currency ? 'active' : ''}`}
                key={`EditLanguageList-${mk}`
              }
              >
                <div className={`flag ${flags[mi.currency]}`} />
                <p>{mi.currency}</p>
              </li>
            );
          })}
        </ul>

        <br/>

        <p>
          Sparxo works with Stripe to process payments.
          Create and connect a stripe account to collect money.
        </p>

        {isIssetStripeAccount !== 'Not connected' &&
          <>
            <p>Currently connected to stripe account</p>
            <div className="well stripe-account-well">
              <div className="row">
                <div className="col-sm-12 text-center">
                  <span
                    className="value"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <i
                      className="icon icon-user"
                      style={{
                        fontSize: '2rem',
                        marginRight: '1rem'
                      }}
                    />
                    <span>
                      {this.state.connectedAccount || _.get(settings, 'connectedAccount', '')}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </>
        }

        <br/>

        <div className="text-center">
          <button
            type="button"
            className="btn btn-pink"
            onClick={this.handleStripeControl}
          >
            {isIssetStripeAccount !== 'Not connected' ?
            'Change Stripe account' :
            'Connect a Stripe account'}
          </button>
        </div>
      </>
    );
  }
}

export default withRouter(StripeConnection);
